/* BASIC APP CONSTANTS */
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const APP_COOKIE_NAME = "APP_COOKIE_NAME";
export const USER_COOKIE_NAME = "USER_COOKIE_NAME";
export const PASS_COOKIE_NAME = "PASS_COOKIE_NAME";
export const USER_ID_COOKIE_NAME = "USER_ID_COOKIE_NAME";
export const SET_CURRENT_ROUTE = "SET_CURRENT_ROUTE";
export const SET_SIDE_MENU_STATE = "SET_SIDE_MENU_STATE";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";
export const SHOW_ACTION_MENU = "SHOW_ACTION_MENU";
export const HIDE_ACTION_MENU = "HIDE_ACTION_MENU";
export const SHOW_BOTTOM_TOOLBAR = "SHOW_BOTTOM_TOOLBAR";
export const HIDE_BOTTOM_TOOLBAR = "HIDE_BOTTOM_TOOLBAR";
export const SET_USER_LIST = "SET_USER_LIST";
export const EDIT_DISABLED_BUTTONS = "EDIT_DISABLED_BUTTONS";
export const SET_LOGS_LIST = "SET_LOGS_LIST";
export const THEME = "THEME";

/* <---- BASIC APP CONSTANTS ----> */

/* SOCKET CONSTANTS */
export const CONNECTED = "connected";
export const DISCONNECTED = "disconnected";
/* <---- SOCKET CONSTANTS ----> */

/* CONFIGURATION */
export const CONFIGURATION_FORM_TOOGLE_LOADING =
	"CONFIGURATION_FORM_TOOGLE_LOADING";
export const SET_CONFIGURATION = "SET_CONFIGURATION";
/* <---- CONFIGURATION ----> */

/* USER */
export const SET_PROFILE = "SET_PROFILE";
/* <---- USER ----> */

/* USERS */
export const ADD_NEW_USER = "ADD_NEW_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const OPEN_USER_FORM = "OPEN_USER_FORM";
export const CLOSE_USER_FORM = "CLOSE_USER_FORM";
export const EDIT_SELECTED_USER = "EDIT_SELECTED_USER";
export const USERS_FORM_TOOGLE_LOADING = "USERS_FORM_TOOGLE_LOADING";
/* <---- USERS ----> */

/* REFERRAL */
export const SET_REFERRAL_LIST = "SET_REFERRAL_LIST";
export const ADD_NEW_REFERRAL = "ADD_NEW_REFERRAL";
export const UPDATE_REFERRAL = "UPDATE_REFERRAL";
export const DELETE_REFERRAL = "DELETE_REFERRAL";
export const OPEN_REFERRAL_FORM = "OPEN_REFERRAL_FORM";
export const CLOSE_REFERRAL_FORM = "CLOSE_REFERRAL_FORM";
export const EDIT_SELECTED_REFERRAL = "EDIT_SELECTED_REFERRAL";
export const REFERRAL_FORM_TOOGLE_LOADING = "REFERRAL_FORM_TOOGLE_LOADING";
/* <---- REFERRAL ----> */

/* CONTACT */
export const SET_CONTACT_LIST = "SET_CONTACT_LIST";
export const ADD_NEW_CONTACT = "ADD_NEW_CONTACT";
export const UPDATE_CONTACT = "UPDATE_CONTACT";
export const DELETE_CONTACT = "DELETE_CONTACT";
export const OPEN_CONTACT_FORM = "OPEN_CONTACT_FORM";
export const CLOSE_CONTACT_FORM = "CLOSE_CONTACT_FORM";
export const EDIT_SELECTED_CONTACT = "EDIT_SELECTED_CONTACT";
export const CONTACT_FORM_TOOGLE_LOADING = "CONTACT_FORM_TOOGLE_LOADING";
/* <---- CONTACT ----> */

/* SUGGESTION */
export const SET_SUGGESTION_LIST = "SET_SUGGESTION_LIST";
export const ADD_NEW_SUGGESTION = "ADD_NEW_SUGGESTION";
export const UPDATE_SUGGESTION = "UPDATE_SUGGESTION";
export const DELETE_SUGGESTION = "DELETE_SUGGESTION";
export const OPEN_SUGGESTION_FORM = "OPEN_SUGGESTION_FORM";
export const CLOSE_SUGGESTION_FORM = "CLOSE_SUGGESTION_FORM";
export const EDIT_SELECTED_SUGGESTION = "EDIT_SELECTED_SUGGESTION";
export const SUGGESTION_FORM_TOOGLE_LOADING = "SUGGESTION_FORM_TOOGLE_LOADING";
/* <---- SUGGESTION ----> */

/* SUBSCRIPTION */
export const SET_SUBSCRIPTION_LIST = "SET_SUBSCRIPTION_LIST";
export const ADD_NEW_SUBSCRIPTION = "ADD_NEW_SUBSCRIPTION";
export const UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTION";
export const DELETE_SUBSCRIPTION = "DELETE_SUBSCRIPTION";
export const OPEN_SUBSCRIPTION_FORM = "OPEN_SUBSCRIPTION_FORM";
export const CLOSE_SUBSCRIPTION_FORM = "CLOSE_SUBSCRIPTION_FORM";
export const EDIT_SELECTED_SUBSCRIPTION = "EDIT_SELECTED_SUBSCRIPTION";
export const SUBSCRIPTION_FORM_TOOGLE_LOADING =
	"SUBSCRIPTION_FORM_TOOGLE_LOADING";
/* <---- SUBSCRIPTION ----> */

/* REVIEW */
export const SET_REVIEW_LIST = "SET_REVIEW_LIST";
export const ADD_NEW_REVIEW = "ADD_NEW_REVIEW";
export const UPDATE_REVIEW = "UPDATE_REVIEW";
export const DELETE_REVIEW = "DELETE_REVIEW";
export const OPEN_REVIEW_FORM = "OPEN_REVIEW_FORM";
export const CLOSE_REVIEW_FORM = "CLOSE_REVIEW_FORM";
export const EDIT_SELECTED_REVIEW = "EDIT_SELECTED_REVIEW";
export const REVIEW_FORM_TOOGLE_LOADING = "REVIEW_FORM_TOOGLE_LOADING";
/* <---- REVIEW ----> */

/* APPOINTMENT */
export const SET_APPOINTMENT_LIST = "SET_APPOINTMENT_LIST";
export const ADD_NEW_APPOINTMENT = "ADD_NEW_APPOINTMENT";
export const UPDATE_APPOINTMENT = "UPDATE_APPOINTMENT";
export const DELETE_APPOINTMENT = "DELETE_APPOINTMENT";
export const OPEN_APPOINTMENT_FORM = "OPEN_APPOINTMENT_FORM";
export const CLOSE_APPOINTMENT_FORM = "CLOSE_APPOINTMENT_FORM";
export const EDIT_SELECTED_APPOINTMENT = "EDIT_SELECTED_APPOINTMENT";
export const APPOINTMENT_FORM_TOOGLE_LOADING =
	"APPOINTMENT_FORM_TOOGLE_LOADING";
/* <---- APPOINTMENT ----> */

/* CONSULTATION */
export const SET_CONSULTATION_LIST = "SET_CONSULTATION_LIST";
export const ADD_NEW_CONSULTATION = "ADD_NEW_CONSULTATION";
export const UPDATE_CONSULTATION = "UPDATE_CONSULTATION";
export const DELETE_CONSULTATION = "DELETE_CONSULTATION";
export const OPEN_CONSULTATION_FORM = "OPEN_CONSULTATION_FORM";
export const CLOSE_CONSULTATION_FORM = "CLOSE_CONSULTATION_FORM";
export const EDIT_SELECTED_CONSULTATION = "EDIT_SELECTED_CONSULTATION";
export const CONSULTATION_FORM_TOOGLE_LOADING =
	"CONSULTATION_FORM_TOOGLE_LOADING";
/* <---- CONSULTATION ----> */

/* ROUTES */
export const SET_ALL_ROUTES = "SET_ALL_ROUTES";
export const UPDATE_ROUTE = "UPDATE_ROUTE";
/* <---- ROUTES ----> */

/* ALERT */
export const SET_ALERT_LIST = "SET_ALERT_LIST";
export const ADD_NEW_ALERT = "ADD_NEW_ALERT";
export const UPDATE_ALERT = "UPDATE_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const OPEN_ALERT_FORM = "OPEN_ALERT_FORM";
export const CLOSE_ALERT_FORM = "CLOSE_ALERT_FORM";
export const EDIT_SELECTED_ALERT = "EDIT_SELECTED_ALERT";
export const ALERT_FORM_TOOGLE_LOADING = "ALERT_FORM_TOOGLE_LOADING";
/* <---- ALERT ----> */

